import { useRef, useEffect } from 'react';
import round from 'lodash/round';

export function usePrevious<TValues>(value: TValues): TValues {
  const ref = useRef<TValues>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export const getPercentage = (percent?: number): number => {
  return percent ? round(100 * percent) : 0;
};

export const parseCacheFields = (data: Record<string, any>) =>
  Object.fromEntries(Object.keys(data).map(key => [key, () => data[key as keyof typeof data]]));

// eslint-disable-next-line no-control-regex
export const prepareFileName = (name: string) => name.replace(/[<>:"/\\|?*\x00-\x1F]/g, '_');
